"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetProductShades = void 0;
var _configurationManager = require("@ori/configuration-manager");
var _fetching = require("@ori/fetching");
var _presentationHttp = require("@ori/presentation-http");
var _presentationUtils = require("@ori/presentation-utils");
var _react = require("react");
var _queriesNet = require("../queries-net");
var _mapProductShadesQuery = require("../utils/mapProductShadesQuery");
/* istanbul ignore file @preserve -- api */

const useGetProductShades = ({
  productCode,
  enabled = true
}) => {
  const {
    graphQlNetUrl
  } = (0, _configurationManager.useServiceUrls)(['graphQlNet']);
  const {
    headers,
    loading: loadingHeaders
  } = (0, _presentationHttp.useHeaders)();
  const {
    data,
    isValidating,
    error
  } = (0, _fetching.useGraphqlQuery)({
    query: _queriesNet.getProductShades,
    url: graphQlNetUrl,
    headers,
    variables: {
      productCode
    },
    skip: loadingHeaders || !enabled,
    swrConfig: (0, _presentationUtils.getRetryErrorSwrOptions)()
  });
  const loading = (0, _react.useMemo)(() => isValidating || !data && !error, [data, error, isValidating]);
  const result = (0, _react.useMemo)(() => ({
    data: data ? (0, _mapProductShadesQuery.mapProductShadesQuery)(data) : undefined,
    loading,
    error
  }), [data, error, loading]);
  return result;
};
exports.useGetProductShades = useGetProductShades;
//# sourceMappingURL=useGetProductShades.js.map